import React, { useContext, useEffect, useState } from "react";
import { Heading } from "../../../components";
import Input from "../../../components/Input/Input";
import { ResumeContext } from "../../../contexts/resumeContext";
import styles from "./SocialForm.module.css";
import { deleteIcon, plus } from "../../../components/Icons/Icons";

const socialList = [
  "Linkedin",
  "Github",
  "Website",
  "Whatsapp",
  "Behance",
  "Dribbble",
  "Instagram",
  "Twitter",
  "Pinterest",
  "Skype",
];

function SocialForm() {
  const newSocialBlock = (social) => ({
    label: social,
    link: "",
  });

  const { updateResumeInfo, resumeInfo } = useContext(ResumeContext);

  const [socialDetails, setSocialDetails] = useState(
    Object.values(resumeInfo?.social || {}) || []
  );

  useEffect(() => {
    updateResumeInfo.current("social", socialDetails, resumeInfo);
  }, [socialDetails]);

  const handleChange = (e, ix) => {
    let socialDetailsArr = [...socialDetails];
    let socialDetailsObj = socialDetailsArr[ix];
    socialDetailsObj[e.target.name] = e.target.value;
    socialDetailsArr[ix] = socialDetailsObj;
    setSocialDetails(socialDetailsArr);
  };

  const addBlock = (social) => {
    let socialDetailsArr = [...socialDetails, newSocialBlock(social)];
    setSocialDetails(socialDetailsArr);
  };

  const deleteBlock = (ix) => {
    const socialDetailsArr = [...socialDetails];
    socialDetailsArr.splice(ix, 1);
    setSocialDetails(socialDetailsArr);
  };

  return (
    <div>
      <Heading
        content="Social Links"
        subheading="You can add links to websites you want hiring managers to see! Perhaps It will be  a link to your portfolio, LinkedIn profile, or personal website"
      />
      {socialDetails.map((link, ix) => (
        <div className="block">
          <button className="delete-btn" onClick={() => deleteBlock(ix)}>
            <img src={deleteIcon} />{" "}
          </button>
          <div className="row">
            <div className="col">
              <Input
                label="Label"
                name="label"
                onChange={(e) => handleChange(e, ix)}
                value={link.label}
              />
            </div>
            <div className="col">
              <Input
                label="Link"
                autofocus
                name="link"
                onChange={(e) => handleChange(e, ix)}
                value={link.link}
              />
            </div>
          </div>
        </div>
      ))}
      <div className={styles.socialWrapper}>
      {socialList.map((social) => (
        <button className={styles.socialBtn} onClick={() => addBlock(social)}><img src={plus}/> {social}</button>
      ))}
      <button className={styles.socialBtn} onClick={() => addBlock("")}><img src={plus}/> Custom Link</button>
      </div>
    </div>
  );
}

export default SocialForm;
